import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { getData, postData } from "../api";
// import { getChatHistory, getItemDetailUrl, getItemImages, PREV_IMG, deleteItemUrl, getLocationsUrl } from "../constants/endPoints";
import { getChatHistory, getItemDetailUrl, getItemImages, PREV_IMG, deleteItemUrl, getLocationsUrl, getItemsUrl } from "../constants/endPoints";
import { cleanOptional, convertFromBase64, hasPrice, whatsappNumber, convertNumber, convertToBase64, currencyFormat, isValidEmail, setLoadingState, hasYear, optText, driverLabel } from "../constants/helper";
import { getItemData } from "../Hooks/useItemParams";
import DataNotFound from "./DataNotFound";
import useConsole from "../Hooks/useConsole";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faEnvelopeOpen, faInbox, faMailBulk, faPhone, faStar } from "@fortawesome/free-solid-svg-icons";
import { FaAd,FaWhatsapp, FaEdit, FaEnvelopeOpen, FaInbox, FaPhone, FaRegEdit, FaSellsy, FaTrash, FaTypo3, FaArrowLeft, FaExclamationTriangle } from "react-icons/fa";
import { MdEmail, MdOutlineFormatTextdirectionLToR } from "react-icons/md";
import { getCurrentUserId } from "../constants/sessionHelper";
import { notify } from "../Components/AppNotification";
import { Modal, Button, Space } from 'antd';
import { PARTS, SERVICES } from "../constants";
import { compose } from 'redux';
import { updateLocation } from '../ReduxStore/actions/locationAction';
import { connect } from 'react-redux';
import ShareButton from "../Components/ShareButton";
import GoBackButton from "../Components/GoBackButton";
import MotorAd from "../Pages/Home/MotorAd";
import NoMotorAd from "./Components/NoMotorAd";
import ProductItem from "../Pages/Home/ProductItem";
import { updateAds } from '../ReduxStore/actions/adsAction';
import { getAdsUrl } from "../constants/endPoints";
import SEO from "../Components/SEO";
import ContactCta from "../Components/ContactCta";


const ProductDetail = ({ ...props }) => {
    const { id } = useParams();
    // console.log(id);
    const [productId, setProductId] = useState((prev) => convertFromBase64(id));
    const [productDetails, setProductDetail] = useState({ data: null, isLoading: true });
    const [images, setImages] = useState([]);
    const [confirm, setConfirm] = useState(false);
    const [suggested, setSuggested] = useState({ isLoading: false, data: [] });
    const history = useHistory();

    const getAds = async () => {
        try {
            props.updateAds({ isLoading: true });
            const res2 = await getData(getAdsUrl());
            if (!res2.data) {
                props.updateAds({ data: [], isLoading: false });
                return;
            }
            props.updateAds({ isLoading: false, data: res2.data.response });
        } catch (e) {
            props.updateAds({ isLoading: false });
        }
    }

    const getSuggestedProducts = async (product) => {
        try {
            setSuggested((prev) => ({ ...prev, isLoading: true }));
            let reqData = getItemData();
            reqData.category_id = product.category_id;
            if (product.manufacturer_id && product.manufacturer_id != -1) {
                reqData.manufacturer_id = product.manufacturer_id;
            }
            let res = await postData(getItemsUrl("search", 9, 0), reqData);
            let data = (res.data || []).filter((val) => val.id != product.id).slice(0, 8);
            setSuggested({ isLoading: false, data });
        } catch (e) {
            setSuggested({ isLoading: false, data: [] });
        }
    }
    useConsole("productDetails", productDetails);
    const showModal = () => {
        setConfirm(true);
    }

    const hideModal = () => {
        setConfirm(false);
    }

    const getProductData = async () => {
        try {
            setProductDetail((prev) => { return { ...setLoadingState(prev, true) } });
            let res = await getData(getItemDetailUrl("get", 10, 0, productId));
            setProductDetail((prev) => { return { ...setLoadingState(prev, false, res.data) } });
            // an ad without photos gets a 404 "Sorry" here: show no images, not an error
            let imagesRes = null;
            try { imagesRes = await getData(getItemImages(productId)); } catch (e) { imagesRes = null; }
            setImages(Array.isArray(imagesRes && imagesRes.data) ? [...imagesRes.data] : []);
        } catch (e) {
            console.log(e);
            setProductDetail((prev) => { return { ...setLoadingState(prev, false) } });
        }
    }
    const startChat = async () => {
        try {
            let data = {
                item_id: productDetails.data.id,
                buyer_user_id: getCurrentUserId(),
                seller_user_id: productDetails.data.added_user_id
            }
            notify("Aguarde", "iniciando o chat....", 'info');
            let res = await postData(getChatHistory(), data);
            console.log(res.data);
            history.push({ pathname: '/chats', chat: res.data });
        } catch (e) {
            notify('Erro', 'não foi possível iniciar o chat', 'error');
        }
    }
    const getLocation = async () => {
        try {
            props.updateLocation({ isLoading: true });
            const res2 = await getData(getLocationsUrl("get", 100, 0));
            if (!res2.data) {
                props.updateLocation({ isLoading: false });
                return;
            }
            props.updateLocation({ isLoading: false, data: res2.data });
            console.log("Props location data", props);

        } catch (e) {
            console.log(e);
            props.updateLocation({ isLoading: false });
        }
    }
    const deleteItem = async () => {
        // items/item_delete/api_key/teampsisthebest
        const data = { item_id: productDetails.data.id };
        let res = await postData(deleteItemUrl(), data);
        console.log(res.data);
        history.push('/');
    }
    const editAd = () => {
        const data = { item_id: productDetails.data.id };
        history.push('/edit_item/' + convertToBase64(data.item_id));
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        setProductId(convertFromBase64(id));
        getLocation();

    }, [id])
    useEffect(() => {
        if (productId != null) {
            getProductData();
            getAds();
        }
    }, [productId])

    useEffect(() => {
        if (productDetails.data != null) {
            getSuggestedProducts(productDetails.data);
        }
    }, [productDetails.data && productDetails.data.id])

    const sliderKey = (productDetails.data ? productDetails.data.id : '') + ':' + images.map((img) => img.img_id).join(',');
    useEffect(() => {
        if (productDetails.data != null) {
            window.onProductDetailLoaded();
        }
    }, [sliderKey])
    let loc;
    if (productId && productDetails.data != null) {

        props.location.data.forEach(data => {
            if (data.id == productDetails.data.item_location_id) {
                loc = data;
            }
        })
        console.log("location data: ", loc);
    }

    const d = productDetails.data;
    const manuName = d ? optText(d.manufacturer_id == -1 ? d.manufacturer_name : (d.manufacturer && d.manufacturer.name)) : '';
    const modelName = d ? optText(d.model_id == -1 ? d.model_name : (d.model && d.model.name)) : '';
    // vehicle-style title (Marca Modelo Ano); Peças with their own name use it instead
    const vehicleTitle = d ? [manuName, modelName, hasYear(d.year) ? d.year : ''].filter(Boolean).join(' ') : '';
    const useVehicleTitle = !!(d && manuName && !(d.category_id == PARTS && d.title));
    const seoName = d ? (useVehicleTitle
        ? vehicleTitle
        : (d.title || 'Anúncio')) : null;
    // every other filled-in detail from the DB; empty / "0" values are skipped
    const positive = (v) => convertNumber(v) > 0 ? v : '';
    const extraRows = d ? [
        ['Lugares', positive(d.max_passengers)],
        ['Portas', positive(d.no_of_doors)],
        ['Horas', optText(d.hours)],
        ['Motorista', driverLabel(d.is_driver)],
        ['Proprietários', optText(d.no_of_owner)],
        ['Direcção', optText(d.steering_position)],
        ['Versão', optText(d.trim_name)],
        ['Negociável', String(d.negotiable) === '1' ? 'Sim' : ''],
    ].filter(([, v]) => v) : [];
    const seoTitle = seoName ? `${seoName} | InfoMotores` : undefined;
    const seoDescription = d ? [
        d.condition_of_item && d.condition_of_item.name,
        d.mileage && convertNumber(d.mileage) > 0 ? `${currencyFormat(d.mileage)} km` : null,
        d.fuel_type && d.fuel_type.fuel_name,
        d.transmission && d.transmission.name,
    ].filter(Boolean).join(', ')
        + (hasPrice(d.price) ? `. ${currencyFormat(d.price)} Kz` : '')
        + (d.item_location && d.item_location.name ? `. ${d.item_location.name}, Angola.` : '.') : undefined;
    const seoImage = images && images[0] ? PREV_IMG + images[0].img_path : undefined;
    const seoJsonLd = d ? {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: seoName,
        image: seoImage ? [seoImage] : undefined,
        description: seoDescription,
        brand: (d.manufacturer && d.manufacturer.name) ? { '@type': 'Brand', name: d.manufacturer.name } : undefined,
        offers: !hasPrice(d.price) ? undefined : {
            '@type': 'Offer',
            priceCurrency: 'AOA',
            price: d.price,
            availability: 'https://schema.org/InStock',
            itemCondition: (d.condition_of_item && d.condition_of_item.name === 'Novo') ? 'https://schema.org/NewCondition' : 'https://schema.org/UsedCondition',
        },
    } : undefined;

    return (
        <div className="product-detail-page">
            <SEO title={seoTitle} description={seoDescription} image={seoImage} jsonLd={seoJsonLd} type="product" />
            {/* {console.log(productId && productDetail.data)} */}
            <Modal
                title="Confirme?"
                visible={confirm}
                onOk={deleteItem}
                onCancel={hideModal}
                okText="Sim"
                cancelText="Cancelar"
            >
                <p>Tem certeza de que deseja excluir esta postagem?</p>
            </Modal>
            {(productId && productDetails.data != null) ? <main>


                {productDetails.data.added_user_id == getCurrentUserId() && <div style={
                    {
                        position: 'fixed',
                        bottom: 10,
                        right: 10,
                        display: 'flex',
                        cursor: 'pointer',
                        zIndex: 3,
                        border: "none"
                    }
                }>
                    <div>
                        <button style={{
                            padding: '1em',
                            backgroundColor: '#930002',
                            color: 'white',
                            borderColor: 'black',
                            borderRadius: 100,
                            zIndex: 1,
                            boxShadow: '#8080803d 0px 4px 20px 6px',
                        }} onClick={showModal}><FaTrash size={30} /></button>
                        <button style={{
                            padding: '1em',
                            backgroundColor: '#930002',
                            color: 'white',
                            borderColor: 'black',
                            borderRadius: 100,
                            zIndex: 1,
                            boxShadow: '#8080803d 0px 4px 20px 6px',
                        }} onClick={editAd}><FaEdit size={30} /></button>
                    </div>
                </div>}
                {/* <!-- Breadcrumbs --> */}
                <div className="b-crumbs-wrap">
                    <div className="cont b-crumbs">
                        <ul>
                            <li className="b-crumbs-back">
                                <a onClick={() => { window.history.back(); }}><FaArrowLeft /> Voltar</a>
                            </li>
                            <li>
                                <Link to="/">Motor</Link>
                            </li>
                            {/* brand / model: open the product list filtered by them (real links,
                                so open-in-new-tab works; the name becomes the list's title) */}
                            {
                                productDetails.data.manufacturer && productDetails.data.manufacturer.name && <li>
                                    <Link to={{
                                        pathname: "/products/" + convertToBase64(JSON.stringify({ ...getItemData(), manufacturer_id: productDetails.data.manufacturer.id })),
                                        category_name: productDetails.data.manufacturer.name,
                                    }}>{productDetails.data.manufacturer.name}</Link>
                                </li>
                            }
                            {
                                productDetails.data.model && productDetails.data.model.name && <li>
                                    <Link to={{
                                        pathname: "/products/" + convertToBase64(JSON.stringify({
                                            ...getItemData(),
                                            manufacturer_id: productDetails.data.manufacturer ? productDetails.data.manufacturer.id : '',
                                            model_id: productDetails.data.model.id,
                                        })),
                                        category_name: [productDetails.data.manufacturer && productDetails.data.manufacturer.name, productDetails.data.model.name].filter(Boolean).join(' '),
                                    }}>{productDetails.data.model.name}</Link>
                                </li>
                            }
                            {/* {
                                (productDetails.data.manufacturer.name || productDetails.data.manufacturer_id == -1) &&
                                <li>
                                    <span>{productDetails.data.manufacturer_id == -1 ? productDetails.data.manufacturer_name : productDetails.data.manufacturer.name}
                                        &nbsp;{productDetails.data.model_id == -1 ? productDetails.data.model_name : productDetails.data.model.name}
                                        &nbsp;{productDetails.data.year}</span>
                                </li>
                            }
                            {
                                (!productDetails.data.manufacturer.name && productDetails.data.manufacturer_id != -1) &&
                                <li>
                                    <span>{productDetails.data.title}</span>
                                </li>
                            } */}
                        </ul>
                        {/* <div className="b-crumbs-menu">
                            <a id="b-crumbs-menu" href="#"></a>
                            <ul className="b-crumbs-menulist">
                                <li><a href="product.html">Product: Standart</a></li>
                                <li><a href="product-vehicle.html">Product: Vehicle</a></li>
                            </ul>
                        </div> */}
                    </div>
                </div>

              {/* <GoBackButton></GoBackButton> */}

                <div className="cont maincont">
                    <div style={{ position: "relative" }}>

                    {/* <span className="maincont-line1"></span>
                    <span className="maincont-line2"></span> */}

                    {/* <!-- Product - start --> */}
                    <div className="prod">

                        {/* <!-- Product Slider - start --> */}
                        <div className="prod-slider-wrap" key={sliderKey}>
                            <div className="flexslider prod-slider" id="prod-slider">
                                <ul className="slides">
                                    {images.map((val1, i) => {
                                        return <li>
                                            <a data-fancybox-group="prod" className="fancy-img" href={PREV_IMG + val1.img_path}>
                                                <img src={PREV_IMG + val1.img_path} alt={seoName ? `${seoName} - foto ${i + 1}` : `foto ${i + 1}`} /></a>
                                        </li>
                                    })}

                                </ul>
                                <div className="payment-note-wrap">
                                    <FaExclamationTriangle />
                                    <span className='payment-note'>Atenção: Informamos que não devem ser feitos pagamento sem antes confirmarem a veracidade do produto bem como a documentação do mesmo. Não nos responsabilizamos pela negociação entre vendedor e comprador.</span>
                                </div>
                            </div>

                            <div className="flexslider prod-thumbs" id="prod-thumbs">
                                <ul className="slides">
                                    {images.map((val, i) => {
                                        return <li>
                                            <img src={PREV_IMG + val.img_path} alt={seoName ? `${seoName} - miniatura ${i + 1}` : `miniatura ${i + 1}`} />
                                        </li>
                                    })}

                                </ul>
                            </div>
                        </div>
                        {/* <!-- Product Slider - end --> */}
                        {/* AD below slider */}
                        

                        <div className="row home-item-info">
                            <h5 className="heading-font pt-2">{
                                useVehicleTitle ?
                                <span> {vehicleTitle}</span>
                                : <span>{productDetails.data.title}</span>
                            }</h5>
                            <div className="col-12">
                                {productDetails.data.category_id != SERVICES && <div className="charac-table-wrap pt-1 pb-2">
                                    <h5 className="heading-font mb-2">Características</h5>
                                    <div className="table-responsive">
                                        <table className="charac-table">
                                            <thead>
                                                <tr>
                                                    <td width="10%"></td>
                                                    <td width="20%"></td>
                                                    <td width="20%"></td>
                                                    <td width="20%"></td>
                                                    <td width="20%"></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {optText(productDetails.data.vehicle_category && productDetails.data.vehicle_category.category_name) && <tr>
                                                    <td>Tipo de veículo</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.vehicle_category.category_name}</td>
                                                </tr>}
                                                {optText(productDetails.data.vehicle_brand && productDetails.data.vehicle_brand.name) && <tr>
                                                    <td>Marca do veículo</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.vehicle_brand.name}</td>
                                                </tr>}
                                                {manuName && <tr>
                                                    <td>{productDetails.data.category_id == PARTS ? "Categoria" : "Marca"}</td>
                                                    <td className="prod-desc-item-c">{manuName}</td>
                                                </tr>}
                                                {modelName && <tr>
                                                    <td>{productDetails.data.category_id == PARTS ? "Sub Categoria" : "Modelo"}</td>
                                                    <td className="prod-desc-item-c">{modelName}</td>
                                                </tr>}
                                                {/* older Peças listings: build-type "Tipo de veículo" */}
                                                {!(productDetails.data.vehicle_category && productDetails.data.vehicle_category.category_name) &&
                                                    productDetails.data.build_type && productDetails.data.build_type.car_type && <tr>
                                                    <td>Tipo de veículo</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.build_type.car_type}</td>
                                                </tr>}
                                                {optText(productDetails.data.item_type) && <tr>
                                                    <td>Tipo</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.item_type}</td>
                                                </tr>}
                                                {hasYear(productDetails.data.year) && <tr>
                                                    <td>Ano</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.year}</td>
                                                </tr>}
                                                {productDetails.data.mileage && convertNumber(productDetails.data.mileage) > 0 && <tr>
                                                    <td>Quilômetros</td>
                                                    <td className="prod-desc-item-c">{currencyFormat(productDetails.data.mileage)} Km</td>
                                                </tr>}
                                                {productDetails.data.color.color_value && <tr>
                                                    <td>Cor</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.color.color_value}</td>
                                                </tr>}
                                                {productDetails.data.fuel_type.fuel_name && <tr>
                                                    <td>Tipo de combustível</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.fuel_type.fuel_name}</td>
                                                </tr>}
                                                {productDetails.data.transmission.name && <tr>
                                                    <td>Caixa</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.transmission.name}</td>
                                                </tr>}
                                                {optText(productDetails.data.engine_power) && <tr>
                                                    <td>Poder do motor</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.engine_power}</td>
                                                </tr>}
                                                {optText(productDetails.data.plate_number) && <tr>
                                                    <td>Matricula</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.plate_number}</td>
                                                </tr>}
                                                {optText(productDetails.data.condition_of_item && productDetails.data.condition_of_item.name) && <tr>
                                                    <td>Estado</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.condition_of_item.name}</td>
                                                </tr>}
                                                {extraRows.map(([label, value]) => <tr key={"extra-" + label}>
                                                    <td>{label}</td>
                                                    <td className="prod-desc-item-c">{value}</td>
                                                </tr>)}
                                                {productDetails.data.sell_type && <tr>
                                                    <td>Modalidade</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.sell_type == "Rent" ? "Aluguel" : "Venda"}</td>
                                                </tr>}
                                                {productDetails.data.item_location.name && <tr>
                                                    <td>Provincia</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.item_location.name}</td>
                                                </tr>}
                                                <tr>
                                                    <td>Carregada</td>
                                                    <td className="prod-desc-item-c">{productDetails.data.added_date_str}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>}
                                {productDetails.data.category_id == SERVICES &&
                                    <ul className="information ps-0">
                                        {productDetails.data.service_area && <li><span>Área de serviço: &nbsp;{productDetails.data.service_area} </span></li>}
                                        {loc && loc.name && <li><span>Província: &nbsp;{loc.name} </span></li>}
                                    </ul>
                                }
                                {productDetails.data.services && productDetails.data.services.length > 0 &&
                                    <ul className="service-tags ps-0 mt-2 mb-2">
                                        {productDetails.data.services.map((service, i) => (
                                            <li className="service-tag" key={"service-tag-" + i}>{service.service_name}</li>
                                        ))}
                                    </ul>
                                }
                                {productDetails.data.category_id != SERVICES && (hasPrice(productDetails.data.price)
                                    ? <section aria-label="Price" class="price-heading pt-1">
                                    <div data-testid="ad-card-price" class="price heading-font product-detail-price">
                                        <span>{currencyFormat(productDetails.data.price)}</span><sup class="ooa-od9pi4 e4bdfv60">kz</sup>
                                    </div>
                                </section>
                                    : <div className="product-detail-contact"><ContactCta item={productDetails.data} /></div>)}
                                <div className="pt-1 pb-1">
                                    <ShareButton
                                        title={
                                            useVehicleTitle ? vehicleTitle : productDetails.data.title
                                        }
                                    />
                                </div>
                                <div className="pt-1">
                                    <div className="row">
                                        <h5 className="product-detail-phone app-color">
                                            <span className="heading-font">
                                                <FaPhone />
                                                <a href={"tel:" + productDetails.data.phone_number} className='app-color'>
                                                    &nbsp;{productDetails.data.phone_number}
                                                </a>
                                            </span>
                                        </h5>
                                    </div>
                                    {String(cleanOptional(productDetails.data.second_phone_number)).replace(/\D/g, '').length >= 6 && (
                                        <div className="pt-1">
                                            <div className="row">
                                                <h5 className="product-detail-phone app-color">
                                                    <div className="contact-box">
                                                        <a
                                                            className="om-button om-button--whatsapp contact-button text-light"
                                                            href={`https://wa.me/${whatsappNumber(productDetails.data.second_phone_number)}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <FaWhatsapp size={23} />
                                                            &nbsp; &nbsp;
                                                            <span className="contact-box__label">
                                                                Contactar por WhatsApp
                                                            </span>
                                                        </a>
                                                    </div>
                                                </h5>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {isValidEmail(productDetails.data.email) && <div className="pt-1">
                                    <div className="row">
                                        <h5 className="product-detail-email app-color">
                                            <div class="contact-box">
                                                <a class="om-button contact-button" href={"mailto:" + productDetails.data.email} >
                                                    <MdEmail size={23} />
                                                    &nbsp; &nbsp;
                                                    <span class="contact-box__label">Contactar Vendedor</span></a>
                                            </div>
                                        </h5>
                                    </div>
                                </div>}
                                {productDetails.data.category_id != SERVICES && <div className="pt-0">
                                    <div className="row">
                                        <h6 className="product-detail-phone"><span className="heading-font"><FaSellsy /> {productDetails.data.sell_type == "Rent" ? "Alugar" : "Venda"}</span></h6>
                                    </div>
                                </div>}

                                {
                                    optText(productDetails.data.description) && <div>
                                        <h5>
                                            Descrição:
                                        </h5>
                                        <p>
                                            {productDetails.data.description}
                                        </p>
                                    </div>
                                }
                                {
                                    productDetails.data.highlight_info && <div>
                                        <h5>
                                            Informação:
                                        </h5>
                                        <p>
                                            {productDetails.data.highlight_info}
                                        </p>
                                    </div>
                                }
                                {
                                    optText(productDetails.data.address) && <div>
                                        <h5>
                                            Endereço:
                                        </h5>
                                        <p>
                                            {productDetails.data.address}
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>

                        {/* <!-- Product Content - end --> */}

                    </div>
                    {/* <!-- Product - end --> */}

                    {
                            props.ads && props.ads.data && props.ads.data.length >= 3 &&
                                props.ads.data.map((val, i) => {
                                    return i == 2 ? <MotorAd ad={val} key={"ad-" + i} /> : null;
                                })
                        }

                        {/* <!-- Product Content - start --> */}



                    <div className="prod-desc">
                        {productDetails.data.description && <div>
                            <h5>Descrição</h5>
                            <p style={{ color: '#868ca7' }}>{productDetails.data.description}</p>
                        </div>}
                        <h5 className="pt-4">Informação <span className="prod-desc-profile">do usuário</span></h5>
                        <div className="row pt-2">
                            <div className="col-12 user-info">
                                <Link className="user-info-link" to={"/seller/" + convertToBase64(productDetails.data.added_user_id)} target="_blank" rel="noopener noreferrer">
                                    <div className="row align-items-center">
                                        <div className="col-auto">
                                            {productDetails.data.user.user_profile_photo ? (
                                                <img
                                                    className="user-info-avatar"
                                                    src={PREV_IMG + productDetails.data.user.user_profile_photo}
                                                    alt={productDetails.data.user.user_name || ''}
                                                    onError={(e) => { e.target.style.display = 'none'; if (e.target.nextElementSibling) e.target.nextElementSibling.style.display = 'flex'; }}
                                                />
                                            ) : null}
                                            <span
                                                className="user-info-avatar user-info-avatar--fallback"
                                                style={{ display: productDetails.data.user.user_profile_photo ? 'none' : 'flex' }}
                                            >
                                                {(productDetails.data.user.user_name || '?').trim().charAt(0).toUpperCase() || '?'}
                                            </span>
                                        </div>
                                        <div className="col ps-0" style={{ minWidth: 0 }}>
                                            {productDetails.data.user.user_name && <div>
                                                <label><h6>{productDetails.data.user.user_name}</h6></label>
                                            </div>}
                                            {productDetails.data.user.user_phone && <div>
                                                <label><FontAwesomeIcon icon={faPhone} size={10} className="ic-rm4" />{productDetails.data.user.user_phone}</label>
                                            </div>}
                                            {isValidEmail(productDetails.data.user.user_email) && <div>
                                                <label><FontAwesomeIcon icon={faEnvelope} size={10} className="ic-rm4" />{productDetails.data.user.user_email}</label>
                                            </div>}
                                        </div>
                                    </div>
                                </Link>
                                <div className="row rating-container">
                                </div>
                            </div>
                        </div>



                    </div>
                    </div>
                    {suggested.data.length > 0 && <div className="specials-wrap home-page">
                        <div className="cont specials pt-4 w-100">
                            <h2>PRODUTOS SUGERIDOS</h2>
                            <div className="specials-list">
                                <div className="row mob-scroll mob-scroll-row-h330">
                                    {
                                        suggested.data.map((val, i) => {
                                            return <ProductItem val={val} index={i} type="suggested" key={"suggested-" + i} />
                                        })
                                    }
                                </div>
                            </div>
                            <span className="special-line1"></span>
                            <span className="special-line2"></span>
                        </div>
                    </div>}

                </div>

            </main>
                : productDetails.isLoading ? <div className="d-flex justify-content-center align-items-center mt-8" style={{ height: 400 }}>
                    <Spinner animation="grow" />
                </div> : (productDetails.isLoading ? null : <DataNotFound title="Anúncio não disponível" message="Este anúncio já não está disponível ou foi removido." showAllLink={true} />)}
        </div>
    );
}

// const mapLocationWithProps = (state) => {
//     return {
//         location: state.location
//     }
// }
// const mapLocationActionWithProps = (dispatch) => {
//     return {
//         updateLocation: (_data) => dispatch(updateLocation(_data)),
//     }
// }

// export default compose(
//     connect(mapLocationWithProps, mapLocationActionWithProps),
// )(ProductDetail);

const mapLocationWithProps = (state) => {
    return {
        location: state.location,
        ads: state.ads
    }
}
const mapLocationActionWithProps = (dispatch) => {
    return {
        updateLocation: (_data) => dispatch(updateLocation(_data)),
        updateAds: (_data) => dispatch(updateAds(_data)),
    }
}

export default compose(
    connect(mapLocationWithProps, mapLocationActionWithProps),
)(ProductDetail);